module.exports = __webpack_public_path__ + "img/15-6.f14bb880.png";